import {
  Box,
  Typography,
  Paper,
  Button
} from "@mui/material";
import {
  EmojiEvents as TargetsIcon,
  Add as AddIcon
} from "@mui/icons-material";
import {useEffect, useState} from "react";
import NoteDialog from "./NoteDialog";
import {getClientTargets, saveClientTarget} from "../../services/TraineeService";
import {getErrorMessage} from "../../enums/ErrorMessages";
import {useMessageContext} from "../../contexts/MessageContext";
import ClientTarget from "./ClientTarget";
import {colors, borders, shadows} from "../ui/colors";
import {t as coachT} from "../dashboard/coach/coachTokens";
import {RTL} from "../../cache/CacheRtl";

const ClientPageTargets = ({client, coach = false}) => {
  const [newNote, setNewNote] = useState(false);
  const [clientTargets, setClientTargets] = useState([]);
  const {notificationHandler} = useMessageContext();
  const [reload, setReload] = useState(false);

  useEffect(() => {
    getClientTargets(client.id).then(r => {
      setClientTargets(r.data);
    }).catch(e => {
      notificationHandler.error(getErrorMessage(e.response.data?.errorCode));
    })
  }, [reload]);

  const handleNewNote = (note) => {
    const body = {
      traineeId: client.id,
      message: note.message
    }
    saveClientTarget(body)
        .then(() => setNewNote(false))
        .then(() => setReload(prv => !prv))
        .then(() => notificationHandler.success("מטרה נשמרה בהצלחה"))
        .catch(e => {
          notificationHandler.error(getErrorMessage(e.response.data?.errorCode));
        })
  }

  return (
      <>
        <NoteDialog
            initValue={{}}
            approve={handleNewNote}
            close={() => setNewNote(false)}
            isOpen={newNote}
        />

        <Box sx={coach ? {} : { margin: "20px" }}>
          <RTL>
          <Paper
              dir="rtl"
              sx={{
                backgroundColor: coach ? coachT.white : colors.white,
                border: coach ? `1px solid ${coachT.border}` : borders.default,
                borderRadius: coach ? coachT.r : borders.radius.lg,
                boxShadow: coach ? coachT.sh : shadows.card,
                overflow: "hidden",
              }}
              elevation={0}
          >
            {/* Header */}
            <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: coach ? "16px 22px" : "16px 20px",
                  backgroundColor: coach ? coachT.bg : colors.bg,
                  borderBottom: coach ? `1px solid ${coachT.border}` : borders.default
                }}
            >
              <Box sx={{display: "flex", alignItems: "center", gap: coach ? 1.5 : 1}}>
                {coach ? (
                    <Box sx={{width: 40, height: 40, borderRadius: "11px", background: coachT.white, border: `1px solid ${coachT.border}`, display: "flex", alignItems: "center", justifyContent: "center"}}>
                      <TargetsIcon sx={{color: coachT.t2, fontSize: 22}}/>
                    </Box>
                ) : (
                    <TargetsIcon sx={{ color: colors.textSecondary, fontSize: "20px" }} />
                )}
                <Typography
                    sx={{
                      fontWeight: coach ? 800 : 600,
                      fontSize: coach ? "17px" : "16px",
                      color: coach ? coachT.text : colors.textPrimary,
                      letterSpacing: coach ? "-0.2px" : 0,
                    }}
                >
                  מטרות לקוח
                </Typography>
              </Box>

              {coach ? (
                  <Box component="button" onClick={() => setNewNote(true)} sx={{
                    display: "inline-flex", alignItems: "center", gap: "5px",
                    background: coachT.green, color: "#fff",
                    height: 34, px: "15px", borderRadius: coachT.rs,
                    fontSize: "13px", fontWeight: 600,
                    border: "none", cursor: "pointer", fontFamily: "inherit",
                    transition: "all .14s",
                    "&:hover": {background: coachT.greenDark, transform: "translateY(-1px)", boxShadow: "0 4px 12px rgba(1,187,167,.35)"},
                  }}>
                    <AddIcon sx={{fontSize: 16}}/>
                    הוסף מטרה
                  </Box>
              ) : (
                  <Button
                      onClick={() => setNewNote(true)}
                      variant="contained"
                      startIcon={<AddIcon />}
                      sx={{
                        backgroundColor: colors.success,
                        color: colors.white,
                        fontSize: "13px",
                        padding: "6px 16px",
                        "&:hover": {
                          backgroundColor: colors.successText
                        }
                      }}
                      size="small"
                  >
                    הוסף מטרה
                  </Button>
              )}
            </Box>

            {/* Content */}
            <Box sx={{ padding: coach ? "16px 22px" : "20px" }}>
              {clientTargets.length > 0 ? (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: coach ? 1.25 : 2 }}>
                    {clientTargets
                        .sort((a, b) => b.createdDate - a.createdDate)
                        .map((target, i) => (
                            <ClientTarget
                                reload={() => setReload(prv => !prv)}
                                key={i}
                                target={target}
                                coach={coach}
                            />
                        ))
                    }
                  </Box>
              ) : (
                  <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "200px",
                    flexDirection: "column",
                    gap: 2
                  }}>
                    <TargetsIcon sx={{ fontSize: "48px", color: coach ? coachT.border : colors.borderHover }} />
                    <Typography sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: coach ? coachT.t3 : colors.textSecondary,
                      textAlign: "center"
                    }}>
                      אין מטרות עדיין
                    </Typography>
                    <Typography sx={{
                      fontSize: "14px",
                      color: coach ? coachT.t3 : colors.textMuted,
                      textAlign: "center"
                    }}>
                      לחץ על "הוסף מטרה" כדי להוסיף מטרה ראשונה
                    </Typography>
                  </Box>
              )}
            </Box>
          </Paper>
          </RTL>
        </Box>
      </>
  );
};

export default ClientPageTargets;